
namespace TabAurous.Reports {
    import fld = TabAurous.Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class JewelleryStockShapeWiseGrid extends _Ext.GridBase<TabAurous.Stock.StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.JewelleryShapeWiseReport'; } 
        protected getIdProperty() { return TabAurous.Stock.StockItemRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Stock.StockItemRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Stock.StockItemRow.localTextPrefix; }
        protected getService() { return TabAurous.Stock.JewelleryShapeWiseService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 130 });
            this.addDateRangeFilter("VoucherDate", "Date");
            this.setTitle("");
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Stock/StockJewellery/List',
                    idField: "ProductCode",
                    textField: "ProductCode",
                    multiple: true

                },
                field: 'ProductCode',
                title: 'Product',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push((values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).ProductCodes = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (this.view.params as ReportFiltersRequest).ProductCodes = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
          
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: 'CategoryLkp',
                    multiple: true

                },
                field: 'CategoryId',
                title: 'Category',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CategoryIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (this.view.params as ReportFiltersRequest).CategoryIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: 'SubCategoryLookup',
                    multiple: true

                },
                field: 'SubCategoryIds',
                title: 'Sub Category',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).SubCategoryIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (this.view.params as ReportFiltersRequest).SubCategoryIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            return filters;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            var self = this;
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: TabAurous.Stock.JewelleryShapeWiseService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            buttons.push({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    var items = this.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    }

                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    Q.postToService({
                        service: TabAurous.Stock.JewelleryShapeWiseService.baseUrl + '/ExportExcelWithOutImages',
                        request: {
                            ProductIds: (self.view.params as ReportFiltersRequest).ProductIds,
                            ProductCodes: (self.view.params as ReportFiltersRequest).ProductCodes,
                            CategoryIds: (self.view.params as ReportFiltersRequest).CategoryIds,
                            SubCategoryIds: (self.view.params as ReportFiltersRequest).SubCategoryIds
                        },

                        target: '_blank'
                    });
                }
            });
            buttons.push({
                title: 'Print With Images',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    var items = this.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    }

                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    Q.postToService({
                        service: TabAurous.Stock.JewelleryShapeWiseService.baseUrl + '/ExportExcelWithImages',
                        request: {
                            ProductCodes: (self.view.params as ReportFiltersRequest).ProductCodes,
                            ProductIds: (self.view.params as ReportFiltersRequest).ProductIds,
                            CategoryIds: (self.view.params as ReportFiltersRequest).CategoryIds,
                            SubCategoryIds: (self.view.params as ReportFiltersRequest).SubCategoryIds
                        },

                        target: '_blank'
                    });
                }
            });
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "Jewellery Stock(Shape Wise)"
            }));

            return buttons;
        }
    }
}